import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Menu, X, LogOut, User, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';
import { useState } from 'react';
import logo from '../assets/logo-tecnologie.webp';
import { useAuth } from '../context/AuthContext';

export default function Header() {
  const [open, setOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const loc = useLocation();
  const { user, brand, logout } = useAuth();

  const nav = [
    { label: 'Home', to: '/' },
    { label: 'Nuovo Push', to: '/p/new' },
    { label: 'Dashboard', to: '/dashboard' },
    { label: 'Piani', to: '/pricing' },
    { label: 'Funzionalità', to: '/features' },
  ];
  const isActive = (to) => (to === '/' ? loc.pathname === '/' : loc.pathname.startsWith(to));

  return (
    <header className="sticky top-0 z-40 w-full border-b border-slate-200/80 bg-white/85 backdrop-blur-md">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group">
          <img src={logo} alt="Tecnologie" className="h-9 w-auto" />
          <div className="leading-tight border-l border-slate-200 pl-2.5 ml-1 hidden sm:block">
            <div className="text-[10.5px] uppercase tracking-[0.14em] text-[#0d63b0] font-semibold">Secure Push</div>
            <div className="text-[10.5px] text-slate-500">by Tecnologie</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {nav.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                isActive(n.to)
                  ? 'text-[#0d63b0] bg-blue-50'
                  : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
              }`}
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2">
          {!user && (
            <>
              <Button asChild variant="ghost" className="text-slate-700 hover:text-[#0d63b0]">
                <Link to="/login">Accedi</Link>
              </Button>
              <Button asChild className="bg-[#0d63b0] hover:bg-[#0a4f8f] text-white shadow-sm">
                <Link to="/register">Registrati</Link>
              </Button>
            </>
          )}
          {user && (
            <div className="relative">
              <button onClick={() => setMenuOpen((v) => !v)} className="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-1.5 hover:border-[#0d63b0]/40">
                <div className="h-7 w-7 rounded-full bg-[#0d63b0] text-white text-xs font-bold flex items-center justify-center">{(brand?.name || user.email)[0]?.toUpperCase()}</div>
                <span className="text-sm font-medium text-slate-800">{brand?.name || user.email}</span>
                <ChevronDown className="h-3.5 w-3.5 text-slate-500" />
              </button>
              {menuOpen && (
                <div onMouseLeave={() => setMenuOpen(false)} className="absolute right-0 mt-2 w-60 rounded-lg border border-slate-200 bg-white shadow-lg overflow-hidden z-50">
                  <div className="px-4 py-3 border-b border-slate-100">
                    <div className="text-xs text-slate-500">Accesso come</div>
                    <div className="text-sm font-semibold text-slate-900 truncate">{user.email}</div>
                    {brand?.slug && <div className="mt-1 text-[11px] text-[#0d63b0] font-mono">/b/{brand.slug}</div>}
                  </div>
                  <Link to={brand ? `/b/${brand.slug}` : '/'} onClick={() => setMenuOpen(false)} className="flex items-center gap-2 px-4 py-2 text-sm text-slate-700 hover:bg-slate-50"><LayoutDashboard className="h-4 w-4" /> Landing brand</Link>
                  <Link to="/account/brand" onClick={() => setMenuOpen(false)} className="flex items-center gap-2 px-4 py-2 text-sm text-slate-700 hover:bg-slate-50"><User className="h-4 w-4" /> Personalizza brand</Link>
                  <Link to="/account/domain" onClick={() => setMenuOpen(false)} className="flex items-center gap-2 px-4 py-2 text-sm text-slate-700 hover:bg-slate-50"><LayoutDashboard className="h-4 w-4" /> Dominio custom</Link>
                  <Link to="/account/subscription" onClick={() => setMenuOpen(false)} className="flex items-center gap-2 px-4 py-2 text-sm text-slate-700 hover:bg-slate-50">Piano: <span className="font-semibold capitalize">{brand?.plan || 'free'}</span></Link>
                  {user?.is_admin && (
                    <Link to="/admin" onClick={() => setMenuOpen(false)} className="flex items-center gap-2 px-4 py-2 text-sm text-amber-700 hover:bg-amber-50 border-t border-slate-100"><User className="h-4 w-4" /> Admin panel</Link>
                  )}
                  <button onClick={() => { logout(); setMenuOpen(false); }} className="w-full flex items-center gap-2 px-4 py-2 text-sm text-red-600 hover:bg-red-50 border-t border-slate-100"><LogOut className="h-4 w-4" /> Esci</button>
                </div>
              )}
            </div>
          )}
        </div>

        <button className="md:hidden p-2 text-slate-700" onClick={() => setOpen(!open)} aria-label="menu">
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white">
          <div className="px-4 py-3 space-y-1">
            {nav.map((n) => (
              <Link key={n.to} to={n.to} onClick={() => setOpen(false)}
                className={`block px-3 py-2 rounded-md text-sm font-medium ${isActive(n.to) ? 'text-[#0d63b0] bg-blue-50' : 'text-slate-700 hover:bg-slate-50'}`}>
                {n.label}
              </Link>
            ))}
            {!user && (
              <>
                <Link to="/login" onClick={() => setOpen(false)} className="block px-3 py-2 rounded-md text-sm font-medium text-slate-700">Accedi</Link>
                <Link to="/register" onClick={() => setOpen(false)} className="block mt-2 text-center bg-[#0d63b0] text-white rounded-md px-3 py-2 text-sm font-semibold">Registrati</Link>
              </>
            )}
            {user && (
              <>
                <Link to="/account/brand" onClick={() => setOpen(false)} className="block px-3 py-2 text-sm text-slate-700">Brand</Link>
                <Link to="/account/subscription" onClick={() => setOpen(false)} className="block px-3 py-2 text-sm text-slate-700">Piano</Link>
                <button onClick={() => { logout(); setOpen(false); }} className="block w-full text-left px-3 py-2 text-sm text-red-600">Esci</button>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
